module.exports = __webpack_public_path__ + "img/blogging-image.36b0102.webp";